/**
 * Decide what the audience must pick before a show can play, from a script's
 * `zoneConfig`.
 *
 * Two independent choices can be required:
 *   - a ZONE / sector — either stadium sectors (`sectorEnabled`) or a plain
 *     named option list (`options`, inputType 'select', e.g. "Spanien"/"Italien")
 *   - a ROW number (`rowEnabled`)
 *
 * The bug this guards against (MM "Flaggen A und B"): a plain option list has
 * `sectorEnabled: false` but still needs the user to choose. Keying the sector
 * choice ONLY off `sectorEnabled` made the client skip the picker entirely and
 * auto-assign zone 0, so every phone played the first flag and no selection UI
 * ever showed — while the data (`enabled`, `options`) was perfectly correct.
 *
 * @param {object|null|undefined} zc  the script's zoneConfig
 * @returns {{ needsSelection: boolean, hasSector: boolean, hasRow: boolean }}
 */
export function zoneSelectionNeeded(zc) {
  if (!zc?.enabled) return { needsSelection: false, hasSector: false, hasRow: false };
  // A sector/zone choice is needed when there are named options to pick from,
  // OR the legacy sector flag is set. The `?? (!rowEnabled && enabled)` fallback
  // keeps old configs working where `sectorEnabled` was never written.
  const hasSector =
    (zc.options?.length ?? 0) > 0 || (zc.sectorEnabled ?? (!zc.rowEnabled && zc.enabled));
  const hasRow = zc.rowEnabled || false;
  return { needsSelection: hasSector || hasRow, hasSector, hasRow };
}
